import type { FC } from "react";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  type SelectChangeEvent,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
  value: string;
  onChange: (template: string) => void;
  kaerFormatOnly?: boolean;
}

export const KAER_WORKER_CSV_TEMPLATE = "mitarbeiterupload";

const CsvExport: FC<Props> = ({ value, onChange, kaerFormatOnly = false }) => {
  const { t } = useTranslation();

  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <FormControl fullWidth={true}>
          <InputLabel id="csv_export">{t("csv_export")}</InputLabel>
          <Select
            labelId="csv_export"
            id="csv_export"
            value={value}
            label={t("csv_export")}
            onChange={handleChange}
          >
            {!kaerFormatOnly && [
              <MenuItem key="vistec" value="vistec">
                Vistec
              </MenuItem>,
              <MenuItem key="tutoolio" value="tutoolio">
                Tutoolio
              </MenuItem>,
              <MenuItem key="labor" value="labor">
                Labor
              </MenuItem>,
              <MenuItem key="vorsorgekartei" value="vorsorgekartei">
                Vorsorgekartei
              </MenuItem>,
            ]}
            <MenuItem value={KAER_WORKER_CSV_TEMPLATE}>
              Mitarbeiter-Upload
            </MenuItem>
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default CsvExport;
